import Sprite = PIXI.Sprite;
import Core from '../../Core/Core';
import { HudActions, HudEmitter } from '../../Managers/Hud/HudEmitter';
import { Popup } from '../../Managers/Popups';
import { createPixiText } from '../../Utils/Utils';
import { ButtonColors } from '../Shared/Buttons/NineSliceButton';
import { TextButton } from '../Shared/Buttons/TextButton';
import { CharacterPopup } from './CharacterPopup';
import { Platform } from '../../SDK/SDK';

export class InfoPopup extends CharacterPopup {
    constructor(width: number, height: number, playerId: string) {
        super(width, height, 'character/character-default', '', Popup.INFO);
        const { header, bg } = this;
        const logo = new Sprite(PIXI.utils.TextureCache['mapui/logo']);
        logo.anchor.set(0.5);
        logo.x = width / 2;
        logo.y = header.y;

        const softgamesLogo = new Sprite(PIXI.utils.TextureCache['mapui/logo-softgames']);
        softgamesLogo.scale.set(1.5);
        softgamesLogo.anchor.set(0.5);
        softgamesLogo.x = width / 2;
        softgamesLogo.y = header.y + header.height * 0.7;
        let last: PIXI.Container = softgamesLogo;

        const idText = createPixiText(
            `Player id: ${playerId}`,
            new PIXI.Rectangle(
                softgamesLogo.x,
                last.y + last.height * 2.5,
                width * 0.9,
                height * 0.05
            ),
            'Baloo',
            30,
            28,
            0xd53700
        );

        last = idText;
        const playButton = new TextButton({
            width: width * 0.5,
            height: height * 0.15,
            btnText: Core.local.getText('playon'),
            color: ButtonColors.GREEN,
            outline: 0x3e6c69,
        });
        playButton.on('trigger', () =>
            HudEmitter.instance.emit(HudActions.CLOSE_POPUP, Popup.INFO)
        );
        if (sgPlatform === Platform.Network) {
            //@ts-ignore
            this.addChild(header, softgamesLogo, logo, playButton);
        } else {
           //@ts-ignore
            this.addChild(header, softgamesLogo, logo, idText, playButton);
        }

        playButton.x = width / 2;
        playButton.y = last.y + last.height + playButton.height * 0.5;

        const newHeight = playButton.y + playButton.height / 2 + 50;

        bg.height = Math.min(newHeight, height);
    }
}
